<script>
	import { nanoid } from "nanoid";
	import FormRow from "../../../components/FormRow.svelte";
	import FormColumn from "../../../components/FormColumn.svelte";
	import TextInput from "../../../components/TextInput.svelte";

	// props
	export let id = nanoid();
	export let firstName = null;
	export let firstNameLabel = "First name";
	export let surname = null;
	export let surnameLabel = "Last name";
	export let required = true;
	export let disabled = null;
</script>

<FormRow>
	<FormColumn>
		<TextInput
			id="{id}_firstName"
			maxlength="50"
			{required}
			{disabled}
			label={firstNameLabel}
			bind:value={firstName}
		/>
	</FormColumn>
	<FormColumn>
		<TextInput id="{id}_surname" maxlength="50" {required} {disabled} label={surnameLabel} bind:value={surname} />
	</FormColumn>
</FormRow>
